<div class="card options-card">
  <div class="card-header bp-card-header">
    <i class="far fa-credit-card payment-options-icon"></i>
    <p class="font-weight-light bp-text">Ways to Pay</p>
  </div>
  <div class="card-body">

        <button class="btn btn-link btn-block clearfix accordion-btn" (click)="showOnline=!showOnline">
          <!--<i *ngIf="!showOnline || !showOnlineDropped" class="fas fa-angle-right fa-2x accordion-arrow"></i>
          <i *ngIf="showOnline || showOnlineDropped" class="fas fa-angle-down fa-2x accordion-arrow"></i>-->
          <div class="accordion-title-div pull-left font-weight-light bp-text bp-medium-text">Online</div>
        </button>
        <div class="container accordion-container">
          <div class="row">
            <h3 class="bp-medium-text">
              <span>
                <strong>Pay (No Fee)</strong>
              </span>
            </h3>
            <p class="bp-text bp-small-text tall-p">
              Pay now online with your checking/savings account for no additional
              <br />
              charge. Once logged in, you can save your banking account information
              <br />
              for easy future payments. To set up your banking account, you'll need
              <br />
              your bank name, bank account number and routing number.
            </p>
          </div>
          <div class="row">
            <h4 class="red-link-header"><a style="width: 16%;" class="bp-link-red float-right">PAY NOW<i class="fas fa-chevron-right view-more-arrow red-link-arrow"></i></a></h4>
          </div>
          <div class="row">
            <h3 class="bp-medium-text">
              <span>
                <strong>Pay with Debit Card/Credit Card (No Fee)</strong>
              </span>
            </h3>
            <p class="bp-text bp-small-text tall-p">
              Credit Card payments can be made through BillMatrix, a separate company not
              <br />
              affiliated with Southern Company. BillMatrix will charge a service fee of to process
              <br />
              the payment.
              <br />
              <br />
              Submit your payment seven days a week, 24 hours a day. You will need your account number along with a valid credit card.
              <br />
              Note: There is a maximum amount of $600.00 that can be charged at one time to a credit card with a limit of five (5) transactions in a 30 day period.
            </p>
            <div class="row">
              <h4 class="red-link-header"><a style="width: 41%;" class="bp-link-red float-right">PAY WITHOUT LOGGING IN<i class="fas fa-chevron-right view-more-arrow red-link-arrow"></i></a></h4>
            </div>
          </div>
        </div>

        <button class="btn btn-link accordion-btn" (click)="showByPhone=!showByPhone">
          <!--<i *ngIf="!showByPhone" class="fas fa-angle-right fa-2x accordion-arrow"></i>
          <i *ngIf="showByPhone" class="fas fa-angle-down fa-2x accordion-arrow"></i>-->
          <div class="accordion-title-div pull-left font-weight-light bp-text bp-medium-text">By Phone</div>
        </button>
        <div class="container accordion-container">
          <div class="row">
            <p class="bp-text bp-small-text tall-p">
              You can submit your payment by phone through the Southern Company Payment System by BillMatrix.
              Pay using your debit/credit card for a fee of .
            </p>
          </div>
        </div>

        <button class="btn btn-link accordion-btn" (click)="showMail=!showMail">
          <!--<i *ngIf="!showMail" class="fas fa-angle-right fa-2x accordion-arrow"></i>
          <i *ngIf="showMail" class="fas fa-angle-down fa-2x accordion-arrow"></i>-->
          <div class="accordion-title-div pull-left font-weight-light bp-text bp-medium-text">Mail</div>
        </button>
        <div class="container accordion-container">
          <div class="row">
            <h3 class="bp-medium-text">
              <span>
                <strong class="ng-binding">Payment Address</strong>
              </span>
            </h3>
            <p class="bp-text bp-small-text tall-p">
              SET payment address here
            </p>
          </div>
        </div>

        <button class="btn btn-link accordion-btn" (click)="showPerson=!showPerson">
          <!--<i *ngIf="!showPerson" class="fas fa-angle-right fa-2x accordion-arrow"></i>
          <i *ngIf="showPerson" class="fas fa-angle-down fa-2x accordion-arrow"></i>-->
          <div class="accordion-title-div pull-left font-weight-light bp-text bp-medium-text">Person</div>
        </button>
        <div class="container accordion-container">
          <div class="row">
            <h3 class="bp-medium-text">
              <span>
                <strong>Southern Company Office</strong>
              </span>
            </h3>
            <p class="bp-text bp-small-text tall-p">
              Visit your local office and make a payment with cash, check, or money
              <br />
              order for no charge.
              <br />
              Heflin
              <br />
              69.7 miles away
              <br />
              595 Ross St, Heflin, AL 36264
              <br />
              OPEN | 8:15AM - 5:00PM
            </p>
          </div>
          <div class="row">
            <h4 class="red-link-header"><a style="width: 38%;" class="bp-link-red float-right">FIND OTHER LOCATIONS<i class="fas fa-chevron-right view-more-arrow red-link-arrow"></i></a></h4>
          </div>
          <div class="row">
            <h3 class="bp-medium-text">
              <span>
                <strong>Authorized Payment Locations (APL)</strong>
              </span>
            </h3>
            <p class="bp-text bp-small-text tall-p">
              We have thousands of Authorized Payment Locations such as Kroger,
              <br />
              Walmart, Publix and Kmart, so you can choose a time and place that is
              <br />
              convenient for you to make a payment.
              <br />
              <br />
              When you visit an Authorized Payment Location, please bring your power
              <br />
              bill or your account number to make a payment.A fee of $1.50 will be
              <br />
              required.
              <br />
              <br />
              Note: To ensure immediate posting of your
              <br />
              payment, please provide your barcode or ask store agent to process through Western Union or
              <br />
              CheckFreePay.
            </p>
            <div class="row">
              <h4 class="red-link-header"><a style="width: 22%;" class="bp-link-red float-right">FIND AN APL<i class="fas fa-chevron-right view-more-arrow red-link-arrow"></i></a></h4>
            </div>
          </div>
        </div>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/ways-to-pay/ways-to-pay.component.html